export default __webpack_public_path__ + "img/856bef7025050fa519979f848d89fc8d.svg";